import type { Messages } from './en';

export const zh: Messages = {
  'nav.clientHub': '客户中心',
  'nav.menu': '菜单',
  'nav.home': '首页',
  'nav.products': '产品',
  'nav.liveCasino': '真人娱乐场',
  'nav.slots': '老虎机',
  'nav.tableGames': '桌面游戏',
  'nav.library': '游戏库',
  'nav.roadmap': '路线图',
  'nav.assets': '素材',
  'nav.guidelines': '规范',
  'nav.account': '账户',
  'nav.signOut': '退出登录',
  'nav.categoriesAria': '游戏类别',
  'nav.sectionsAria': '主要板块',
  'nav.brandAria': 'RichyPlay 客户中心',
  'nav.comingSoon': '敬请期待',
  'nav.soon': '即将上线',

  'lang.label': '语言',
  'lang.select': '选择语言',

  'category.live': '真人',
  'category.slot': '老虎机',
  'category.instant': '即开',
  'category.table': '桌面游戏',

  'status.planned': '已计划',
  'status.in_progress': '进行中',
  'status.shipped': '已发布',
  'status.available': '可用',
  'status.coming_soon': '敬请期待',
  'status.maintenance': '维护中',

  'common.error': '出现问题',
  'common.checkingSession': '正在验证会话…',
  'common.yes': '是',
  'common.no': '否',
  'common.none': '无',
  'common.active': '启用',
  'common.inactive': '停用',

  'home.eyebrow': '运营商门户',
  'home.title': '客户中心',
  'home.lead':
    '探索 RichyPlay 产品组合 —— 在同一个工作空间中启动试玩、跟踪路线图并下载品牌素材。',
  'home.enterLibrary': '进入游戏库',
  'home.viewRoadmap': '查看路线图',
  'home.browse': '按类别浏览',
  'home.openLibrary': '打开游戏库',

  'library.eyebrow': '游戏库',
  'library.title': '产品组合',
  'library.liveTitle': '真人娱乐场产品组合',
  'library.slotTitle': '老虎机产品组合',
  'library.liveLead': '选择一款真人产品。Blackjack 与 Roulette 已上线，其余即将推出。',
  'liveFamily.roulette': 'Royal Roulette',
  'liveFamily.blackjack': 'Royal Blackjack',
  'liveFamily.autoRoulette': 'Auto Roulette',
  'liveFamily.thunderRoulette': 'Thunder Roulette',
  'liveFamily.infinityBlackjack': 'Infinity Blackjack',
  'liveFamily.baccarat': 'Baccarat',
  'liveFamily.poker': 'Poker',
  'liveFamily.dice': 'Dice',
  'liveFamily.showGames': 'Show Games',
  'library.lead': '搜索并筛选 RichyPlay 游戏目录，在新标签页中启动试玩。',
  'library.search': '搜索游戏…',
  'library.statusFilterAria': '按状态筛选',
  'library.statusAll': '所有状态',
  'library.loading': '正在加载游戏…',
  'library.unavailableTitle': '游戏库不可用',
  'library.unavailableMessage': '无法加载游戏库，游戏目录可能暂时不可用。',
  'library.apiFailedMessage': '无法连接目录 API。请稍后重试或联系支持团队。',
  'library.emptyTitle': '未找到游戏',
  'library.emptyMessage': '请尝试其他搜索词或类别筛选。',
  'library.viewGame': '查看游戏',

  'game.loading': '正在加载游戏…',
  'game.notFound': '未找到游戏。',
  'game.back': '返回',
  'game.breadcrumbAria': '面包屑导航',
  'game.liveCasino': '真人娱乐场',
  'game.slots': '老虎机',
  'game.demoFrameTitle': '{title} 试玩',
  'game.startingDemo': '正在启动试玩会话…',
  'game.demoNotStarted': '无法启动试玩会话。',
  'game.demoBadge': '试玩模式',
  'game.blockedMaintenance': '该游戏正在维护中。',
  'game.blockedComingSoon': '敬请期待 —— 试玩版本尚未发布。',
  'game.blockedNoDemo': '运营商目录未提供该游戏的试玩版本。',
  'game.currency': '货币',
  'game.language': '语言',
  'game.reloadDemo': '重新加载试玩',
  'game.startDemo': '开始试玩',
  'game.openNewTab': '在新标签页打开',
  'game.copyLink': '复制链接',
  'game.copied': '已复制',
  'game.demoFailedTitle': '试玩启动失败',
  'game.demoUrlMissing': '服务器未返回启动链接。',
  'game.demoFailed': '无法启动试玩。',
  'game.highlighted': '重点推荐',
  'game.features': '游戏特色',
  'game.keyFeatures': '核心亮点',
  'liveTable.title': '可用桌台',
  'liveTable.totalResults': '结果总数：',
  'liveTable.download': '下载桌台数据',
  'liveTable.gameId': '游戏 ID',
  'liveTable.tableName': '桌台名称',
  'liveTable.minLimit': '最低限红',
  'liveTable.maxLimit': '最高限红',
  'liveTable.hours': '运营时间 UTC',
  'liveTable.language': '运营语言',
  'liveTable.releaseDate': '发布日期',
  'liveTable.location': '所在地',
  'game.betLevels': '投注等级',
  'game.tableRules': '桌台规则',
  'game.mathConfig': '数学模型配置',
  'game.resources': '相关资源',
  'game.relatedAssets': '相关素材',
  'game.releaseRoadmap': '发布路线图',
  'game.integrationGuidelines': '接入规范',
  'game.information': '游戏信息',
  'game.availableOn': 'Available On',
  'game.operatingLanguage': 'Operating Language',
  'game.uiLanguages': 'UI Languages',
  'game.platformDesktop': '电脑',
  'game.platformTablet': '平板',
  'game.platformMobile': '手机',
  'game.downloads': 'Downloads',
  'game.mediaPack': 'Media Pack',
  'game.gameData': 'Game Data (PDF)',
  'game.download': 'Download',
  'game.gameDataSoon': '游戏数据表即将添加。',

  'spec.numericId': '数字 ID',
  'spec.minBetPerLine': '每线最小投注',
  'spec.minTotalBet': '最小总投注',
  'spec.maxTotalBet': '最大总投注',
  'spec.maxTotalBetAnte': 'Ante 下最大总投注',
  'spec.reels': '转轴',
  'spec.rows': '行数',
  'spec.payType': '派奖方式',
  'spec.payLinesValue': '{count} 条线',
  'spec.symbolPays': '符号派奖',
  'spec.betMultiplier': '投注倍数',
  'spec.maxMultiplierWin': '最大倍数奖金',
  'spec.maxExposure': '最大风险敞口',
  'spec.bonusBuyX': '购买奖励 X',
  'spec.anteBetX': 'Ante 投注 X',
  'spec.rtps': 'RTP',
  'spec.hitFrequency': '中奖频率',
  'spec.oneIn': '{value} 次中 1 次',
  'spec.hasReplay': '回放',
  'spec.hasBuySpins': '购买旋转',
  'spec.hasInstantBonus': '即时奖励',
  'spec.hasHyperplay': 'Hyperplay',
  'spec.hasAnteBet': 'Ante 投注',
  'spec.releaseDate': '发布日期',
  'spec.symbol': '游戏标识',
  'spec.referenceId': '参考 ID',
  'spec.provider': '供应商',
  'spec.product': '产品',
  'spec.gameType': '游戏类型',
  'spec.category': '类别',
  'spec.theme': '主题',
  'spec.technology': '技术',
  'spec.rtp': 'RTP',
  'spec.volatility': '波动性',
  'spec.maxWin': '最高赢奖',
  'spec.paylines': '支付线',
  'spec.grid': '转轴布局',
  'spec.bonusFrequency': '奖励频率',
  'spec.bonusFrequencyValue': '{value} 局中 1 次',
  'spec.jackpot': '奖池',
  'spec.betRange': '投注范围',
  'spec.defaultBet': '默认投注',
  'spec.currency': '货币',
  'spec.languages': '语言',
  'spec.demoAvailable': '提供试玩',
  'spec.tournaments': '锦标赛',
  'spec.highlighted': '重点推荐',
  'spec.status': '状态',
  'spec.version': '版本',
  'spec.lastUpdated': '最近更新',

  'roadmap.eyebrow': '产品路线图',
  'roadmap.title': '即将推出',
  'roadmap.lead': '按类别跟踪即将发布和已上线的游戏。',
  'roadmap.bannerAria': '即将发布',
  'roadmap.soonTitle': '敬请期待',
  'roadmap.loading': '正在加载路线图…',
  'roadmap.error': '无法加载路线图内容。',
  'roadmap.emptyTitle': '暂无路线图内容',
  'roadmap.emptyMessage': '该类别下尚无已发布的条目。',
  'roadmap.itemCount': '{count} 个条目',
  'roadmap.target': '目标：{date}',
  'roadmap.viewInLibrary': '在游戏库中查看',

  'upcoming.title': '即将发布',
  'upcoming.playDemo': '试玩',
  'upcoming.prev': '上一组',
  'upcoming.next': '下一组',

  'assets.eyebrow': '品牌素材',
  'assets.title': '素材包',
  'assets.lead': '下载标志、主视觉与营销素材。使用规则请参见{link}。',
  'assets.leadLink': '素材规范',
  'assets.loading': '正在加载素材…',
  'assets.error': '无法加载素材包。',
  'assets.downloadFailed': '下载失败。',
  'assets.emptyTitle': '暂无素材',
  'assets.emptyForGame': '该游戏尚未关联任何素材包。',
  'assets.emptyGeneral': '素材包发布后将显示在此处。',
  'assets.pack': '素材包',
  'assets.updated': '更新于 {date}',
  'assets.download': '下载',
  'assets.search': '按游戏名称搜索…',
  'assets.searchEmpty': '没有匹配该名称的游戏。',

  'guidelines.eyebrow': '文档',
  'guidelines.title': '规范',
  'guidelines.lead': '接入说明、素材使用与运营商参考资料。',
  'guidelines.all': '全部',
  'guidelines.integration': '接入',
  'guidelines.assets': '素材',
  'guidelines.loading': '正在加载规范…',
  'guidelines.error': '无法加载规范。',
  'guidelines.emptyTitle': '暂无规范',
  'guidelines.emptyMessage': '已发布的规范将显示在此处。',
  'guidelines.index': '目录',
  'guidelines.navAria': '规范导航',
  'guidelines.articleLoading': '正在加载文章…',
  'guidelines.notFound': '未找到该规范。',
  'guidelines.notFoundShort': '未找到',
  'guidelines.updated': '更新于 {date}',
  'guidelines.external': '内容托管在外部站点。',
  'guidelines.openDocument': '打开文档',
  'guidelines.typeGuide': '指南',
  'guidelines.typeGuideline': '规范',

  'account.eyebrow': '您的账户',
  'account.title': '个人资料',
  'account.email': '电子邮箱',
  'account.language': '界面语言',
  'account.recentActivity': '近期活动',
  'account.loadingActivity': '正在加载活动记录…',
  'account.activityUnavailable': '暂时无法获取近期活动。',
  'account.noActivity': '暂无近期活动记录。',

  'event.login': '已登录',
  'event.logout': '已退出',
  'event.libraryView': '查看了游戏库',
  'event.gameView': '查看了游戏',
  'event.demoLaunch': '启动了试玩',
  'event.demoLaunchFailed': '试玩启动失败',
  'event.assetDownload': '下载了素材',
  'event.guidelineView': '查看了规范',
  'event.roadmapView': '查看了路线图',

  'auth.title': '客户中心',
  'auth.subtitle': '使用您的运营商账号登录',
  'auth.email': '电子邮箱',
  'auth.password': '密码',
  'auth.rememberMe': '记住我',
  'auth.signIn': '登录',
  'auth.signInFailed': '登录失败',
  'auth.signInError': '无法登录，请检查账号信息后重试。',
  'auth.forgotPassword': '忘记密码？',
  'auth.inviteOnly': '仅限受邀访问。请联系您的 RichyPlay 客户代表。',
  'auth.visitSiteAria': '前往 richyplay.live',

  'footer.navAria': '页脚',
  'footer.tagline': '面向运营商的 RichyPlay 老虎机与真人娱乐场内容门户。',
  'footer.rights': '保留所有权利。',
  'footer.legal': '仅限持牌运营商受邀访问，仅供商务用途。',

  'forgot.eyebrow': '重置密码',
  'forgot.title': '忘记密码',
  'forgot.requestSubtitle': '输入您的邮箱地址，如果账户存在，我们将发送验证码。',
  'forgot.sendCode': '发送验证码',
  'forgot.sendError': '无法发送重置验证码。',
  'forgot.confirmSubtitle': '输入邮件中的验证码并设置新密码。',
  'forgot.code': '验证码',
  'forgot.newPassword': '新密码',
  'forgot.update': '更新密码',
  'forgot.updateError': '无法重置密码。',
  'forgot.doneSubtitle': '密码已更新，您现在可以登录。',
  'forgot.backToSignIn': '返回登录',
};
